import { render, staticRenderFns } from "./Myprofile.vue?vue&type=template&id=6ae61a59&scoped=true"
import script from "./Myprofile.vue?vue&type=script&lang=js"
export * from "./Myprofile.vue?vue&type=script&lang=js"
import style0 from "./Myprofile.vue?vue&type=style&index=0&id=6ae61a59&prod&scoped=true&lang=css"
import style1 from "./Myprofile.vue?vue&type=style&index=1&id=6ae61a59&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae61a59",
  null
  
)

export default component.exports